import React from 'react';
import ProjectCard from './ProjectCard';

function GridView({ projects, fullWidth = false, showFooter = false, totalCount = 0, viewMode = 'grid', onHighlight }) {
  if (!projects || projects.length === 0) {
    return (
      <div className="grid-view-empty">
        <p>No projects in this area.</p>
        <p className="grid-view-empty-hint">Try zooming out or panning the map.</p>
      </div>
    );
  }

  return (
    <div className={`grid-view ${fullWidth ? 'grid-view-full' : ''}`}>
      <div className="grid-view-scroll">
        <div className="grid-view-grid">
          {projects.map((project) => (
            <ProjectCard
              key={project.nid}
              project={project}
              viewMode={viewMode}
              onHighlight={onHighlight}
            />
          ))}
        </div>

        {showFooter && (
          <div className="grid-view-footer">
            <p>End of catalog / {totalCount || projects.length} Active Projects</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default GridView;
